<template>
    <div class="multi-step-filter-list-item f fa-c bf c-el-panel-bg sp-s"
        :class="[!isLocked && allowSwap ? 'c-p show-hover' : '']"
        @click.prevent.stop="onSwapItem"
        :title="isLocked ? lockedTitle : ''">
        <Icon v-if="isLocked"
            class="el--transparent sm-r-s"
            uiSize="xxl"
            name="lock" />
        <div class="f fa-l fv">
            <div class="te-subnote">{{ breadcrumbs }}</div>
            <div class="fg">{{ item.label | athT }}</div>
        </div>
        <div class="fg"></div>
        <VisualBadge v-if="item.badge.length > 0" :lbl="item.badge" />
        <template v-if="!isLocked">
            <Icon v-if="allowSwap"
                class="el--s-s sm-l-s"
                name="chevron-down" />
            <ButtonIcon class="el--transparent el--s-s sm-l-s"
                icon="minus"
                :disabled="!canRemove"
                @click.prevent.stop="onRemoveItem" />
        </template>
    </div>
</template>

<script>
import ButtonIcon from '../../atoms/ButtonIcon.vue';
import VisualBadge from '../../atoms/visuals/Badge.vue';
import Icon from '../../atoms/visuals/Icon.vue';

export default {
    name: 'mead-multi-step-filter-list-item',
    components: {ButtonIcon, VisualBadge, Icon},
    props: {
        /**
         * The multi-step filter item model rendered by this row, including its label, badge,
         * and breadcrumb trail.
         */
        item: {type: Object, default: () => {}},
        /**
         * Minimum number of items that must remain selected overall; combined with selectionCount
         * to determine whether this item can be removed.
         */
        min: {type: Number, default: 0},
        /**
         * Total number of items currently selected in the parent list, used with min to decide
         * whether removing this item would drop the selection below the required minimum.
         */
        selectionCount: {type: Number, default: 0},
        /**
         * Values of items that cannot be removed or swapped; this row is considered locked when
         * its item's value appears in this list.
         */
        lockedItems: {type: Array, default: () => []},
        /**
         * Tooltip text shown on the row (and its lock icon) when the item is locked.
         */
        lockedTitle: {type: String, default: ''},
        /**
         * Whether clicking the row (when not locked) opens the popover to swap this item for
         * another; also controls whether the chevron icon is shown.
         */
        allowSwap: {type: Boolean, default: true}
    },
    data() {
        return {};
    },
    methods: {
        onRemoveItem: function () {
            this.$emit('onRemove');
        },
        onSwapItem: function (event) {
            if (this.isLocked || !this.allowSwap) return;
            this.$emit('onSwapItem', event);
        },
    },
    computed: {
        breadcrumbs: function () {
            let label = '';
            for (const crumb of this.item.breadcrumbs) {
                // Dont include current item
                if (crumb.label === this.item.label) break;
                if (label.length !== 0) label += ' > '
                label += MeadCommon.I18N.go(crumb.label);
            }
            return label;
        },
        canRemove: function () {
            return this.min === 0 || this.selectionCount - 1 >= this.min;
        },
        isLocked: function () {
            return this.lockedItems.includes(this.item.value);
        }
    },
};
</script>
<style lang="scss" scoped>
@use '../../../../sass/variables' as *;
.multi-step-filter-list-item {
    letter-spacing: $ls-s;
    border-radius: $br-m;
    line-height: $lh-m;
    white-space: normal;
    transition: background-color 0.5s ease;

    &.show-hover {
        &:active,
        &:hover {
            background-color: var(--c-brand-light-bg);

            .te-subnote {
                color: var(--c-brand-light-fg);
            }
        }
    }

    .te-subnote {
        text-wrap: auto;
    }
}
</style>
